<script lang="ts">
	import * as Yup from "yup";
	import { FormGroup,	Label, Input, InputGroup } from "@sveltestrap/sveltestrap";
	import { useValidations } from "../../../../../SharedSvelte/Forms.svelte";

	const { validateField, getErrors, resetErrors } =	useValidations();

	// Props: string identifiers/text + bindable state for this question
	let {
		name,
		label,
		uiText,
		yesNoSelection = $bindable(),
		description = $bindable(),
	} = $props();

	const trueFalse = [true, false];
	const FREETEXT_REGEX = /^(?=.{1,200}$)[A-Za-z0-9 ,.:;!?'"()&-]+$/;
	const FREETEXT_WARNING = "Please remove invalid characters (Letters, numbers and punctuation allowed).";

	let errors = $derived(getErrors());

	  // Schema handles 'true'/'false' strings coming from radios by transforming into booleans
	const formSchema = Yup.object({
		yesNoSelection: Yup.boolean()
			.transform((val, orig) => {
				if (typeof orig === "string") {
					if (orig.trim() === "") return undefined;
					return orig.trim() === "true";
				}
				return val;
			})
			.required("Please make a selection."),
		description: Yup.string().when("yesNoSelection", {
			is: true,
			then: (s) =>
				s
					.trim()
					.matches(FREETEXT_REGEX, FREETEXT_WARNING)
					.required("Please provide a description."),
			otherwise: (s) => s.notRequired().strip(),
		}),
	});

export async function validate() {
	await validateField(formSchema, "yesNoSelection", { yesNoSelection });
  await validateField(formSchema, "description", { yesNoSelection, description });
}

export function hasErrors() {
	return Object.keys(errors).length ? true : false;
}
	
function handleChange(fieldName, fieldValue) {
		resetErrors();
		const vars = new Map();
		vars.set(fieldName, fieldValue);
		const data = Object.fromEntries(vars);
		if (fieldName === "yesNoSelection" && (fieldValue === "false" || !fieldValue )) description = "";
		for (const key in data) {
			console.log(`${key}: ${data[key]}`);
			validateField(formSchema, key, data);
		}
	}

</script>

<main>
	<div class="row">
		<hr />
		<div class="col-6 col-sm-2 col-xl-1">
			{#each trueFalse as value}
				<FormGroup>
					<Input
						type="radio"
						name={name}
						id="{name}{value}"
						{value}
						label={value ? "Yes" : "No"}
						bind:group={yesNoSelection}
						invalid={Boolean(errors.yesNoSelection)}
						feedback={errors.yesNoSelection}
						on:change={(e) => handleChange("yesNoSelection", e.target.value)}
					/>
				</FormGroup>
			{/each}
		</div>
		<div class="col-6 col-sm-10 col-xl-11">
			<label for={name}>{uiText}</label>
			{#if Boolean(errors?.yesNoSelection)}
				<div id="{name}Error" class="radioButtonInvalid">
					{errors.yesNoSelection}
				</div>
			{/if}
			{#if yesNoSelection === true || yesNoSelection === "true"}
				<FormGroup floating {label} class="mt-2">
					<Input
						type="text"
						bind:value={description}
						invalid={Boolean(errors.description)}
						feedback={errors.description}
						on:input={(e) => handleChange("description", e.target.value)}
					/>
				</FormGroup>
			{/if}
		</div>
	</div>
</main>

<style>
	.radioButtonInvalid {
		color: var(--bs-form-invalid-color);
		font-size: 0.875em;
		margin-top: 0.25rem;
		width: 100%;
	}
</style>